<template>
  <div class="function">
    <div class="TopBann">
      <!-- <topBarnav></topBarnav> -->
      <div class="middle-Main">
        <div class="it-main">
          <div class="item-txt">
            <span class="items-a">专属空间</span>
            <span class="items-b"
              >企业可以自由、安全、低成本地创建个性化的专属企业书院，员工扫描加入书院，平台实施大数据教务管理</span
            >
            <span class="items-c">海量课程</span>
            <span class="items-d"
              >企业书院可以以企业战略、业务和拟解决问题为主题自建课程，也可以从“融e学·明商道”平台上定制、预约或者免费获取海量课程</span
            >
          </div>
          <div class="items-image">
            <img src="../../assets/introduce/sm.png" class="" />
          </div>
        </div>
      </div>
    </div>
    <div class="function-two">
      <div class="ft-main">
        <img src="../../assets/introduce/fct-1.png" class="ft-a" />
        <div class="ft-b">
          <span class="items-ft-a mt">班级培训</span>
          <span class="items-ft-b"
            >因材施教，分众分层分类设置班级，配备个性化学习计划，全员在线学习，平台实施监控</span
          >
          <span class="items-ft-a mb">在线直播</span>
          <span class="items-ft-b"
            >直播教室随开随播，实时传递领导经营意图，沟通商业路径，便捷地组织培训、直播会议</span
          >
        </div>
      </div>
    </div>
    <div class="function-thr">
      <div class="ft-main">
        <div class="ft-c">
          <span class="items-ft-a mk">问卷调查</span>
          <span class="items-ft-b"
            >面向客户一键导入问题，实时了解市场需求，贴心服务客户面向员工一键导入业务，征寻各方意见，统一思想、统一行动</span
          >
          <span class="items-ft-a mb">考试考核</span>
          <span class="items-ft-b"
            >有学必考，考评结合，以考促学，实时提升学习针对性和实效性</span
          >
        </div>
        <img src="../../assets/introduce/fct-2.png" class="ft-thr" />
      </div>
    </div>
    <div class="function-two">
      <div class="ft-main">
        <img src="../../assets/introduce/fct-3.png" class="ft-four" />
        <div class="ft-b">
          <span class="items-ft-a mt">师资预约</span>
          <span class="items-ft-b"
            >平台提供5000以上国内外各行业、各职业、各专业名师资源库，企业线下培训提前预约，快捷、低成本地预约合意的师资</span
          >
          <span class="items-ft-a mt">以学会友</span>
          <span class="items-ft-b"
            >企业书院是员工职业能力提升、员工学艺交友的平台，也是企业文化建设、员工情感交流的精神家园</span
          >
        </div>
      </div>
    </div>
    <div class="item-compare">
      <img src="../../assets/introduce/fct-5.png" class="item-a" />
      <div class="cmp-a">
        <div class="ft-main1">
          <div class="xx-left"></div>
          <span class="cmp-b">版本比较</span>
          <div class="xx-right"></div>
        </div>
      </div>
      <div class="cmp-c">
        <span>免费版本：可以使用部分功能，供用户体验使用。</span>
        <span class="ckl"
          >企业版本：全面免除平台使用费，每个学员只需48元享受全年平台所有功能，同时用户可以从平台挑选20门精选课程学习</span
        >
      </div>
      <div class="image-main">
        <div class="ft-main1">
          <img src="../../assets/introduce/table.png" class="images-table" />
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import topBarnav from "../introducePage/component/navbar";
import foot from "@/views/introducePage/component/footer";
export default {
  metaInfo() {
    return {
      title:
        this.$route.meta.title +
        "-明商道_企业培训系统_企业培训解决方案服务商-中潮教育",
      meta: [
        {
          name: "keyWords",
          content:
            "明商道,融E学,企业培训,企业培训系统,企业培训管理系统,企业书院,企业大学"
        },
        {
          name: "description",
          content:
            "融E学·明商道-企业一站式线上线下培训平台，包含线上选课、线上培训、讲师预约、会议直播、在线考试、能力测评、员工学习数据管理等定制化的应用，帮助您解决企业培训中任何烦恼。创建企业书院,占领商道制高点。"
        }
      ]
    };
  },
  name: "function",
  components: {
    foot,
    topBarnav
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.function {
  background: #ffffff;
}
.TopBann {
  width: 100%;
  height: 490px;
  background-image: url("../../assets/introduce/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.middle-Main {
  display: flex;
  justify-content: center;
}
.it-main {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.item-txt {
  margin-top: 100px;
  margin-right: 100px;
}
.item-txt span {
  text-align: left;
  color: #ffffff;
  display: block;
}
.items-a {
  font-size: 30px;
  font-weight: 700;
  font-family: PingFang SC, PingFang SC-Bold;
}
.items-b {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 1px;
  margin-top: 10px;
  font-family: PingFang SC, PingFang SC-Regular;
}
.items-c {
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 1px;
  margin-top: 60px;
  font-family: PingFang SC, PingFang SC-Bold;
}
.items-d {
  width: 500px;
  margin-top: 10px;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  font-family: PingFang SC, PingFang SC-Regular;
}
.items-image img {
  width: 539px;
  height: 360px;
  margin-top: 50px;
}
.function-two {
  margin-top: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.ft-main {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.ft-a {
  width: 587px;
  height: 452px;
}
.ft-b {
  margin-left: 100px;
}
.ft-b span {
  display: block;
  color: #343434;
  text-align: left;
}
.items-ft-a {
  font-family: PingFang SC, PingFang SC-Bold;
  font-size: 24px;
  font-weight: 700;
}
.mt {
  margin-top: 100px;
}
.mb {
  margin-top: 72px;
}
.items-ft-b {
  font-family: PingFang SC, PingFang SC-Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 10px;
}
.function-thr {
  margin-top: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.ft-c {
  margin-right: 43px;
}
.ft-c span {
  display: block;
  color: #353535;
  text-align: left;
}
.ft-thr {
  width: 651px;
  height: 396px;
}
.mk {
  margin-top: 74px;
}
.ft-four {
  width: 543px;
  height: 523px;
}
.item-compare {
  width: 100%;
  background-image: url("../../assets/introduce/fct-4.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.item-a {
  width: 100%;
  height: 140px;
}
.cmp-a {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.ft-main1 {
  width: 750px;
  display: flex;
  justify-content: space-between;
}
.cmp-b {
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  /* line-height: 60px; */
}
.xx-left {
  margin-top: 20px;
  width: 244px;
  height: 1px;
  border: 1px dashed #e2e2e2;
}
.xx-right {
  margin-top: 20px;
  width: 244px;
  height: 1px;
  border: 1px dashed #e2e2e2;
}
.cmp-c {
  text-align: center;
  margin-top: 26px;
}
.cmp-c span {
  display: block;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
}
.ckl {
  margin-top: 10px;
}
.image-main {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.images-table {
  width: 100%;
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/introducePage/function.vue